const Loader = ({ className }) => {
  return (
    <div className={`flex loader ${className}`}>
      <svg className="w-[114px] h-[114px] m-4">
        <circle className="fill-none " cx="57" cy="57" r="52" />
        <circle className="meter-1 stroke-cyan-400" cx="57" cy="57" r="52" />
      </svg>
    </div>
  );
};

export default Loader;
